import { createContext, Context } from 'react';

import { IEncryptionContext } from './interfaces';

export const encryptionContext: Context<IEncryptionContext> = createContext(
  {} as IEncryptionContext
);
